export const UPDATE_CHAT_CONVERSATION_FAILURE = 'UPDATE_CHAT_CONVERSATION_FAILURE';

export const updateChatConversationFailure = error => ({
    type: UPDATE_CHAT_CONVERSATION_FAILURE,
    payload: error,
    error: true,
});
